<template>
  <el-row :gutter="10" style="margin-bottom:10px">
    <el-col :span="4">
      <el-cascader
          v-model="deptId"
          :show-all-levels="false"
          :options="deptCascader"
          :props="optionProps"
          placeholder="部门"
          clearable
      ></el-cascader>
    </el-col>
    <el-col :span="4">
      <el-input v-model="employeeNo" placeholder="员工工号" clearable/>
    </el-col>
    <el-col :span="4">
      <el-input v-model="employeeName" placeholder="员工姓名" clearable/>
    </el-col>
    <el-col :span="4">
      <el-date-picker v-model="selectMonth" type="month" placeholder="请选择月份" value-format="YYYY-MM"/>
    </el-col>
  </el-row>
  <el-row :gutter="10" style="margin-bottom:10px">
    <el-col :span="4">
      <el-select v-model="employeeType" placeholder="员工类型"  clearable>
        <el-option v-for="item in employeeTypeList" :key="item.id" :label="item.employee_type_name" :value="item.id"/>
      </el-select>
    </el-col>
    <el-col :span="4">
      <el-select v-model="laborCompanyId" placeholder="劳务公司"  clearable>
        <el-option v-for="item in laborCompanyList" :key="item.id" :label="item.company_name" :value="item.id"/>
      </el-select>
    </el-col>
    <el-col :span="8">
      <el-button type="primary" @click="getMonthReport" :loading="searchLoading" >搜索</el-button>
      <!--     <el-button type="primary" plain @click="resetParam" >重置</el-button>-->
<!--      <el-button type="primary" @click="alertSum">考勤计算</el-button>-->
      <el-button type="primary" plain @click="exportMonthReport" :loading="exportLoading">导出</el-button>
<!--      <el-button type="primary" plain @click="sendWx">推送</el-button>-->
<!--      <FrameButton :button="sendButton"></FrameButton>-->
    </el-col>
  </el-row>
<!--  <el-row  :gutter="5" style="margin-bottom: 10px">
    <el-col :span="8">
      &lt;!&ndash;      <FrameButton :button="sumButton"></FrameButton>&ndash;&gt;
      <el-button type="primary" @click="alertSum">考勤计算</el-button>
      <el-button type="primary" plain @click="exportMonthReport">导出</el-button>
      <el-button type="primary" plain @click="sendWx">推送</el-button>
    </el-col>
  </el-row>-->
  <el-table :data="pageAttendanceList" :span-method="spanMethod" stripe border style="width: 100%;height: 77%" row-style="height:28px;" size="small">
    <el-table-column label="工号" prop="employee_no" fixed width="85" align="center" ></el-table-column>
    <el-table-column label="姓名" prop="employee_name" fixed width="80" align="center" ></el-table-column>
    <el-table-column label="部门" prop="department_name" fixed width="100" align="center" ></el-table-column>
    <el-table-column label="岗位" prop="job_id" fixed width="70" align="center" ></el-table-column>
    <el-table-column label="职务" prop="position_id" fixed width="70" align="center" ></el-table-column>
    <el-table-column label="入厂日期" prop="entry_factory_date" fixed width="100" align="center" ></el-table-column>
    <el-table-column label="员工类型" prop="employee_type" width="70" align="center" ></el-table-column>
    <el-table-column label="考勤月份" prop="work_month_str" width="70" align="center" ></el-table-column>
    <el-table-column label="应出勤(天)" prop="attendance_days" width="55" align="center" ></el-table-column>
    <el-table-column label="实际出勤(天)" prop="actual_attendance_days" width="65" align="center" ></el-table-column>
    <el-table-column label="应出勤(H)" prop="attendance_hours" width="55" align="center" ></el-table-column>
    <el-table-column label="实际出勤(H)" prop="actual_attendance_hours" width="65" align="center" ></el-table-column>
    <el-table-column label="节假日(H)" prop="holiday_hours" width="55" align="center" ></el-table-column>
    <el-table-column label="G1加班(H)" prop="overtime_hours_work" width="65" align="center" ></el-table-column>
    <el-table-column label="G2加班(H)" prop="overtime_hours_weekend" width="65" align="center" ></el-table-column>
    <el-table-column label="G3加班(H)" prop="overtime_hours_holiday" width="65" align="center" ></el-table-column>
    <el-table-column label="外出(H)" prop="out_hours" width="45" align="center" ></el-table-column>
    <el-table-column label="出差(H)" prop="business_trip_hours" width="45" align="center" ></el-table-column>
    <el-table-column label="补卡次数" prop="replace_card_times" width="45" align="center" ></el-table-column>
    <el-table-column label="请假" prop="month" align="center" >
      <el-table-column label="事假(H)" prop="personal_leave_hours" width="60" align="center" ></el-table-column>
      <el-table-column label="病假(H)" prop="sick_hours" width="60" align="center" ></el-table-column>
      <el-table-column label="产假(H)" prop="maternity_hours" width="60" align="center" ></el-table-column>
      <el-table-column label="陪产假(H)" prop="care_hours" width="70" align="center" ></el-table-column>
      <el-table-column label="婚假(H)" prop="marriage_hours" width="60" align="center" ></el-table-column>
      <el-table-column label="丧假(H)" prop="bereavement_hours" width="60" align="center" ></el-table-column>
      <el-table-column label="哺乳假(H)" prop="breastfeeding_hours" width="70" align="center" ></el-table-column>
    </el-table-column>
    <el-table-column label="旷工(天)" prop="skip_work_days" width="45" align="center" ></el-table-column>
    <el-table-column label="漏卡(次)" prop="miss_sign_times" width="45" align="center" ></el-table-column>
    <el-table-column label="迟到<15分钟(次)" prop="late_or_early_within_5_times" width="80" align="center" ></el-table-column>
    <el-table-column label="迟到<30分钟(次)" prop="late_or_early_within_30_times" width="80" align="center" ></el-table-column>
    <el-table-column label="迟到>30分钟(次)" prop="late_or_early_over_30_times" width="80" align="center" ></el-table-column>
    <el-table-column label="迟到时长(分)" prop="late_minutes" width="70" align="center" ></el-table-column>
    <el-table-column label="早退(次)" prop="leave_early_times" width="45" align="center" ></el-table-column>
    <el-table-column label="早退时长(分)" prop="leave_early_minutes" width="70" align="center" ></el-table-column>
    <el-table-column label="描述" prop="type" width="70" align="center" ></el-table-column>
    <el-table-column v-for="title in titleList" :label="title.day" :prop="title.day" :key="title.day"
                     align="center">
      <el-table-column :label="title.calendar" :prop="title.day" :key="title.day" align="center" show-overflow-tooltip width="60">
        <el-table-column :label="title.week" :prop="title.day" :key="title.day" align="center" show-overflow-tooltip min-width="130">
        </el-table-column>
      </el-table-column>
    </el-table-column>
    <el-table-column label="操作" width="70" align="center" fixed = "right">
      <template #default="scope">
        <el-button type="primary" link @click="showDetail(scope.$index, scope.row)">详情</el-button>
      </template>
    </el-table-column>
  </el-table>
  <div style="display: flex;justify-content: flex-end;margin-top: 5px;width: 100%">
    <el-pagination background layout=" sizes, total, prev, pager, next,"
                   :page-sizes="[2,10,20]"
                   :current-page="currentPage"
                   v-model:page-size="pageSize"
                   :total="listSize"
                   @size-change="handleSizeChange"
                   @current-change="handleCurrentChange"/>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "AttendanceMonth",
  inject: ['$fn'],
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      optionProps: {
        emitPath:false,
        value: 'id',
        label: 'name',
        checkStrictly:true
      },
      sumButton:{
        "component": "button",
        "type": "primary",
        "label": "考勤计算",
        "click": "jsOpenWindow",
        "window": {"component": "frame/FrameForm", "type": "attendance_month_sum","title":"考勤计算",
          "width":800,"height":300}
      },
      sendButton:{
        "component": "button",
        "type": "primary",
        "plain": true,
        "label": "推送",
        "click": "jsOpenWindow",
        "window": {"component": "frame/FrameForm", "type": "attendance_send_query","title":"考勤推送",
          "width":800,"height":350}
      },
      searchLoading: false,
      computationLoading:false,
      exportLoading:false,
      titleList: [],
      attendanceList: [],
      pageAttendanceList: [],
      pageSize:2,
      listSize:0,
      currentPage:1,
      columnCnt:0,
      deptId:'',
      employeeNo:'',
      employeeName:'',
      sendStatus:'',
      confirmStatus:'',
      selectMonth:moment(moment().month(moment().month())).format('YYYY-MM'),
      employeeType:'',
      laborCompanyId:'',
      showDialog:false,
      selectEmployee:{},
      employeeAttendanceList:[],
      deptCascader:[],
      laborCompanyList:[],
      employeeTypeList: []
    }
  },
  methods: {
    spanMethod({rowIndex, columnIndex}){
      if (columnIndex <34 || columnIndex === this.titleList.length+35) {
        if (rowIndex % 4 === 0) {
          return {
            rowspan: 4,
            colspan: 1,
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          }
        }
      }
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getCurrentPageData();
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getCurrentPageData();
    },
    getCurrentPageData(){
      if(!this.attendanceList){
        return
      }

      let startIndex = (this.currentPage - 1) * this.pageSize*6;
      let endIndex = this.currentPage * this.pageSize*6;
      this.pageAttendanceList = this.attendanceList.slice(startIndex, endIndex)

    },
    async getMonthReport() {
      let params = {
        deptId: this.deptId,
        employeeNo: this.employeeNo,
        employeeName: this.employeeName,
        confirmStatus: this.confirmStatus,
        selectMonth: this.selectMonth,
        laborCompanyId: this.laborCompanyId,
        employeeType: this.employeeType,
        sendStatus: this.sendStatus
      }
      console.log(params);
      this.searchLoading = true;
      await this.$http('attendanceMonthService.getAttendanceMonthReport', params, false).then(rtn => {
        //赋值
        this.attendanceList = rtn.returnList;
        this.titleList = rtn.titleList;
        this.listSize = rtn.totalSize;
        this.getCurrentPageData();
        this.searchLoading = false;
      }, errMsg => {
        this.$message.error(errMsg)
        this.searchLoading = false;
      })
    },
    async getDepartmentCascader() {
      this.deptCascader = await this.$http("sysUserDepartmentService.getDepartmentData");
    },
    //获取员工类型
    async getEmployeeType() {
      let params = {modelId: "hr_employee_type"}
      this.employeeTypeList = await this.$http('employeeHRService.getAll',params);
    },
    //获取劳务公司列表
    async getLaborCompany() {
      let params = {modelId: "hr_labor_company"}
      this.laborCompanyList = await this.$http('employeeHRService.getAll', params);
    },
    alertSum() {
      this.$store.dispatch('core/openWindow', {
        component: 'attendance/AttendanceSumForm',
        name: '考勤计算',
        parentData: null,
        width: 800,
        height: 300
      })
    },
    async sumMonthReport() {
      let params = {
        date: this.selectMonth,
        deptId: this.deptId,
        employeeNo: this.employeeNo,
        employeeName: this.employeeName
      }
      this.computationLoading = true;
      await this.$http('attendanceMonthService.sumMonthReport', params, false).then(() => {
        this.$message.success("计算成功");
        this.computationLoading = false;
      }, errMsg => {
        this.$message.error(errMsg)
        console.log(errMsg);//具体的message信息，等同⽤$axios时的error.message
        this.computationLoading = false;
      })
    },
    async sendWx() {
      if (this.sendStatus === 'sent') {
        this.$message.error("推送时请勿筛选已推送数据");
        return;
      }
      let params = {
        attendanceList: this.attendanceList,
        selectMonth: this.selectMonth
      }
      await this.$http('wxAttendanceService.sendAttendanceCheck', params).then(res => {
        if (res === 1) {
          this.$message.success("考勤已推送，部分员工推送失败请注意查看");
        }
        if (res === 0) {
          this.$message.success("考勤已全部推送成功");
        }
      });
    },
    getCol() {
      let params = {date: new Date()}
      this.$http('dingAttendanceService.getAllReportColumnValList', params);
    },
    getLeaveCol() {
      let params = {date: new Date()}
      this.$http('dingAttendanceService.getAllLeaveReportList', params);
    },
    async exportMonthReport() {
      this.exportLoading = true;
      let params = {
        attendanceList: this.attendanceList,
        titleList: this.titleList
      }

      /*window.location.href = sysFile.url;
      this.exportLoading = false;*/
      try {
        let sysFile = await this.$http("dingExportService.exportMonthReportToExcel", params,{timeout:100000});
        // 方法1：创建隐藏的a标签下载
        const link = document.createElement('a');
        link.href = sysFile.url;
        link.download = '月度考勤报表.xlsx'; // 设置文件名
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // 或者方法2：在新窗口打开下载
        // window.open(sysFile.url, '_blank');

      } catch (error) {
        console.error('导出失败:', error);
      } finally {
        this.exportLoading = false;
      }
    },
    showDetail(index, row) {
      this.$store.dispatch('core/openWindow', {
        component: 'attendance/AttendanceMonthDetail',
        name: '月度考勤详情',
        parentData: row,
        width: 1500,
        height: 700
      })
    }
  },
  created() {
    this.getDepartmentCascader();
    this.getLaborCompany();
    this.getEmployeeType();
  }
}
</script>

<style scoped lang="less">

</style>